/*
 * Filename: iva_calculator.js
 * By: J. Nguyen  
 * Date: 4/3/23
 *
 * Description: 
 * This template will be used for page specific logic.  Note that each usage of this 
 * should result in a new subdirectory within the /wp-assets/src/{page folder} and should
 * result in a new entry point in the webpack.common.js
 *
 */


import IvaCalcModule from '../modules/iva-calculator-module'; 

const defaults = {              
  debugMode: false
}

// DOM NODES
const ivaCalcPanel = document.getElementById('iva-calculator-panel');


init();
 
// initilize the module
function init() {
  
  IvaCalcModule(ivaCalcPanel, {});

}


// HELPER FUNCTIONS
//===============================================


// Basic debug function
function debug(msg) { 
  if (defaults.debugMode) {
    console.log(msg);
  }
}

